import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// ScrollTriggerプラグインを登録
gsap.registerPlugin(ScrollTrigger);

export function initHeader() {
  let isSpMenuActive = false;

  const spMenuButton = document.querySelector(
    '[data-element="fixed-sp-menu"]'
  ) as HTMLElement;
  const spMenuLineTop = document.querySelector(
    '[data-element="fixed-sp-menu-line-top"]'
  ) as HTMLElement;
  const spMenuLineBottom = document.querySelector(
    '[data-element="fixed-sp-menu-line-bottom"]'
  ) as HTMLElement;
  const spMenuTextTop = document.querySelector(
    '[data-element="fixed-sp-menu-text-top"]'
  ) as HTMLElement;
  const spMenuTextBottom = document.querySelector(
    '[data-element="fixed-sp-menu-text-bottom"]'
  ) as HTMLElement;

  const headerSpContainer = document.querySelector(
    '[data-element="header-sp-container"]'
  ) as HTMLElement;

  const headerNavList = document.querySelector(
    '[data-element="header-sp-nav-list"]'
  ) as HTMLElement;

  headerNavList.classList.add("is-loaded");

  const DERAY1 = 10;
  const DERAY2 = DERAY1 + 5;
  const DERAY3 = DERAY2 + 2.5;

  let savedScrollPosition = 0;
  let scrollLocked = false;

  // スクロール無効化
  const disableScroll = () => {
    if (scrollLocked) return;
    savedScrollPosition = window.scrollY;

    const scrollBarWidth =
      window.innerWidth - document.documentElement.clientWidth;

    document.body.style.top = `-${savedScrollPosition}px`;
    document.body.style.width = "100%";
    document.body.style.position = "fixed";
    document.body.style.overflow = "hidden";
    document.body.style.paddingRight = `${scrollBarWidth}px`;

    document.documentElement.style.overscrollBehavior = "none";
    document.body.style.overscrollBehavior = "none";

    document.addEventListener("touchmove", preventTouchMove, {
      passive: false,
    });

    scrollLocked = true;
  };

  const enableScroll = () => {
    if (!scrollLocked) return;

    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.width = "";
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";

    document.documentElement.style.overscrollBehavior = "";
    document.body.style.overscrollBehavior = "";

    window.scrollTo(0, savedScrollPosition);
    document.removeEventListener("touchmove", preventTouchMove);

    scrollLocked = false;
  };

  // タッチムーブを防止（iOS用）
  const preventTouchMove = (e: TouchEvent) => {
    const target = e.target as HTMLElement;
    const isScrollableElement = target.closest('[data-scrollable="true"]');

    if (!isScrollableElement) {
      e.preventDefault();
    }
  };

  const spMenuOpen = () => {
    if (!isSpMenuActive) {
      spMenuButton.classList.add("is-active");
      spMenuLineTop.classList.add("is-active");
      spMenuLineBottom.classList.add("is-active");
      spMenuTextTop.classList.add("is-active");
      spMenuTextBottom.classList.add("is-active");
      headerSpContainer.classList.add("is-sp_menu_active");
      isSpMenuActive = !isSpMenuActive;

      disableScroll();

      setTimeout(() => {
        if (isSpMenuActive) {
          // headerSpLogoBlock.classList.add("is-active");
        }
      }, DERAY1);
      setTimeout(() => {
        if (isSpMenuActive) {
          headerNavList.classList.add("is-active");
        }
      }, DERAY2);
      setTimeout(() => {
        if (isSpMenuActive) {
          // headerSpSns.classList.add("is-active");
        }
      }, DERAY3);
    } else {
      spMenuButton.classList.remove("is-active");
      spMenuLineTop.classList.remove("is-active");
      spMenuLineBottom.classList.remove("is-active");
      spMenuTextTop.classList.remove("is-active");
      spMenuTextBottom.classList.remove("is-active");
      headerSpContainer.classList.remove("is-sp_menu_active");
      isSpMenuActive = !isSpMenuActive;

      headerNavList.classList.remove("is-active");
      // headerSpSns.classList.remove("is-active");

      enableScroll();
    }
  };

  spMenuButton.addEventListener("click", spMenuOpen);

  // ページ遷移演出側からの強制クローズイベント
  window.addEventListener("page-transition:forceCloseSpMenu", () => {
    if (isSpMenuActive) {
      spMenuOpen(); // 閉じる分岐へ
    }
  });

  window.addEventListener("swup:contentReplaced", () => {
    if (isSpMenuActive) {
      spMenuOpen();
    }
  });

  window.addEventListener("resize", () => {
    if (isSpMenuActive && window.matchMedia("(min-width: 43rem)").matches) {
      enableScroll();
    }
  });
}
